var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1171275092(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3311,
    cy: 24.3145,
    r: 23.3311,
    fill: "#4535AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3049 25.2144V21.625C32.3049 17.1382 30.5102 15.3435 26.0235 15.3435H20.6394C16.1526 15.3435 14.3579 17.1382 14.3579 21.625V27.0091C14.3579 31.4958 16.1526 33.2905 20.6394 33.2905H24.2288",
    stroke: "white",
    strokeWidth: 1.53832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3049 25.2144V21.625C32.3049 17.1382 30.5102 15.3435 26.0235 15.3435H20.6394C16.1526 15.3435 14.3579 17.1382 14.3579 21.625V27.0091C14.3579 31.4958 16.1526 33.2905 20.6394 33.2905H24.2288",
    stroke: "white",
    strokeWidth: 1.53832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3049 25.2144V21.625C32.3049 17.1382 30.5102 15.3435 26.0235 15.3435H20.6394C16.1526 15.3435 14.3579 17.1382 14.3579 21.625V27.0091C14.3579 31.4958 16.1526 33.2905 20.6394 33.2905H24.2288",
    stroke: "white",
    strokeWidth: 1.53832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8179 19.8303L18.8444 19.8303",
    stroke: "white",
    strokeWidth: 1.53832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8179 24.317L18.8444 24.317",
    stroke: "white",
    strokeWidth: 1.7947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2285 28.8038H18.8444",
    stroke: "white",
    strokeWidth: 1.7947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8332 33.9987C31.5821 33.9987 32.9998 32.581 32.9998 30.8321C32.9998 29.0832 31.5821 27.6654 29.8332 27.6654C28.0843 27.6654 26.6665 29.0832 26.6665 30.8321C26.6665 32.581 28.0843 33.9987 29.8332 33.9987Z",
    stroke: "white",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 34.3334L32.6665 33.6667",
    stroke: "white",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275092);
export default __webpack_public_path__ + "static/media/Group 1171275092.2684bb0302fb0fdb4f19dc39362fb4b8.svg";
export { ForwardRef as ReactComponent };